module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.9656cd12.svg";